// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__rsDls"};